"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.proxies = exports.general = exports.exchangesV1 = exports.dappHub = exports.daiV1 = void 0;

var _ERC = _interopRequireDefault(require("./abis/ERC20.json"));

var _WETH = _interopRequireDefault(require("./abis/WETH9.json"));

var _DSValue = _interopRequireDefault(require("./abis/DSValue.json"));

var _DSGuard = _interopRequireDefault(require("./abis/DSGuard.json"));

var _DSChief = _interopRequireDefault(require("./abis/DSChief.json"));

var _DSSpell = _interopRequireDefault(require("./abis/DSSpell.json"));

var _DSSpellBook = _interopRequireDefault(require("./abis/DSSpellBook.json"));

var _DSProxy = _interopRequireDefault(require("./abis/DSProxy.json"));

var _DSProxyFactory = _interopRequireDefault(require("./abis/DSProxyFactory.json"));

var _MatchingMarket = _interopRequireDefault(require("./abis/MatchingMarket.json"));

var _ProxyCreationAndExecute = _interopRequireDefault(require("./abis/ProxyCreationAndExecute.json"));

var _SaiProxyCreateAndExecute = _interopRequireDefault(require("./abis/SaiProxyCreateAndExecute.json"));

var _ProxyRegistry = _interopRequireDefault(require("./abis/ProxyRegistry.json"));

var _SaiTop = _interopRequireDefault(require("./abis/SaiTop.json"));

var _SaiTub = _interopRequireDefault(require("./abis/SaiTub.json"));

var _SaiTap = _interopRequireDefault(require("./abis/SaiTap.json"));

var _SaiVox = _interopRequireDefault(require("./abis/SaiVox.json"));

var _SaiMom = _interopRequireDefault(require("./abis/SaiMom.json"));

var _GemPit = _interopRequireDefault(require("./abis/GemPit.json"));

var daiV1 = {
  saiTop: _SaiTop["default"],
  tub: _SaiTub["default"],
  tap: _SaiTap["default"],
  vox: _SaiVox["default"],
  mom: _SaiMom["default"],
  pit: _GemPit["default"]
};
exports.daiV1 = daiV1;
var dappHub = {
  dsValue: _DSValue["default"],
  dsEthToken: _WETH["default"],
  dsGuard: _DSGuard["default"],
  dsChief: _DSChief["default"],
  dsSpell: _DSSpell["default"],
  dsSpellBook: _DSSpellBook["default"],
  dsProxy: _DSProxy["default"]
};
exports.dappHub = dappHub;
var exchangesV1 = {
  makerOtc: _MatchingMarket["default"]
};
exports.exchangesV1 = exchangesV1;
var general = {
  erc20: _ERC["default"]
};
exports.general = general;
var proxies = {
  oasisProxy: _ProxyCreationAndExecute["default"],
  saiProxy: _SaiProxyCreateAndExecute["default"],
  dsProxyFactory: _DSProxyFactory["default"],
  proxyRegistry: _ProxyRegistry["default"]
};
exports.proxies = proxies;